import { AssignBulkResponse, AttendanceMetricsResponse, ChannelOwnerResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * O painel do atendimento e a distribuição (F210): quem atende cada número,
 * a carga de cada um, e passar várias conversas de uma vez. Tudo atrás de
 * `communication.queue.write` — é trabalho de quem supervisiona.
 */
export const setChannelOwner = async (accountId, input) => ChannelOwnerResponse.parse(await request(`/api/v1/communication/channels/${accountId}/owner`, {
    method: 'PUT',
    body: input,
}));
export const fetchAttendanceMetrics = async (query, signal) => {
    const params = new URLSearchParams({ from: query.from, to: query.to });
    if (query.accountId !== undefined)
        params.set('accountId', query.accountId);
    return AttendanceMetricsResponse.parse(await request(`/api/v1/communication/attendance/metrics?${params.toString()}`, { signal }));
};
export const assignConversations = async (input) => AssignBulkResponse.parse(await request('/api/v1/communication/conversations/assign-bulk', {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=communication-attendance.js.map